import React, { Fragment } from 'react'

function ManifestStrip({ totals }) {
    const tiles = [
        { label: 'Véhicules en service', value: totals?.totalVehicles ?? 0 },
        { label: 'Chauffeurs actifs', value: totals?.totalDrivers ?? 0 },
        { label: 'Sur route à l’instant', value: totals?.activeVehiclesNow ?? 0 },
        { label: 'Opérations ce mois', value: totals?.tripsThisMonth ?? 0 },
    ]

  return (
    <Fragment>
        <div className='manifestStrip'>
            {tiles.map(tile => (
                <div className='tile' key={tile.label}>
                    <span className='tileValue'>{tile.value}</span>
                    <span className='tileLabel'>{tile.label}</span>
                </div>
            ))}
        </div>
    </Fragment>
  )
}

export default ManifestStrip
